module.exports = __webpack_public_path__ + "static/img/001.cd9f15bc.png";